import styled from "styled-components";
import { TextField, Button, Link } from "@mui/material";

export const Container = styled.section``;

export const LoginSection = styled.section`
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  padding: 40px;
  max-width: 400px;
  background-color: rgb(250, 250, 250);
  border-radius: 10px;
  box-shadow: 0 0 10px #00000040;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledTextField = styled(TextField).attrs({
  size: "small",
})`
  width: 100%;
  background-color: "yellow";
`;

export const SubmitButton = styled(Button)`
  width: 100%;
`;

export const StyledLink = styled(Link)`
  cursor: pointer;
`;
